import { TWhiteLabelStore } from '../white-label.model';

export function setPanelAccent(themeWrapper: HTMLBodyElement, whiteLabel: TWhiteLabelStore): void {
  themeWrapper.style.setProperty('--panelAccent', whiteLabel.data.panelAccent);
}
